// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductColorButton{background-repeat:no-repeat;background-size:cover;border:1px solid #eaeaea;border-radius:100%;display:block;height:2rem;margin-right:.4rem;position:relative;width:2rem}.ProductColorButton--selected:after{background-color:#fff;border:1px solid #eaeaea;border-radius:100%;content:\"\";height:.75rem;left:calc(50% - .375rem);position:absolute;top:calc(50% - .375rem);width:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
